import script from "./BaseTimer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseTimer.vue?vue&type=script&setup=true&lang=ts"

import "./BaseTimer.vue?vue&type=style&index=0&id=44b3620c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-44b3620c"]])

export default __exports__